export class Kink {
  public label: string;
  public value: number = 0;
  public date: Date;

  constructor(label: string, value: number, date: Date) {
    this.label = this.updateLabel(label.trim().replace('·e', '(e)'));
    this.value = value;
    this.date = date;
  }

  private updateLabel(label: string): string {
    switch (label) {
      case 'Fetichiste':
        return 'Fétichiste';
      case 'Pet (animal de compagnie)':
        return 'Pet (Animal de compagnie)';
      case 'Propriétaire de Petgirl/Petboy':
        return 'Handler (Petplay)';
      case 'Primal Prey':
        return 'Primal Prey (Proie)';
      case 'Expérimentaliste':
        return 'Expérimentaliste';
      case 'Brat (sale gosse)':
        return 'Brat (Sale gosse)';
      default:
        return label;
    }
  }
}
